import React from "react";
import Grid from "../../GridCards/Grid";
const Veterinaria = () => {
  return <Grid />;
};

export default Veterinaria;
